import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

const EyeIcon = (props: SVGProps<any>): ReactElement => {
  return (
    <BaseIcon {...props}>
      <path
        d="M12.5 5.25C5 5.25 2 12 2 12s3 6.75 10.5 6.75S23 12 23 12s-3-6.75-10.5-6.75Z" stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round" strokeLinejoin="round"
      />
    </BaseIcon>
  )
}
export default EyeIcon;